import { FilterSelect } from '@/components';
import { useClientTerminology } from '@/views/list/NetworkTerms';

export const MultiNetworkFilterButtons = (props: {
  network: string;
  updateNetwork: (network: string) => void;
}) => {
  const intl = useClientTerminology();
  return (
    <>
      {['1', 'all'].includes(props.network) && (
        <FilterSelect
          data-testid="filter-select-distribution"
          label={intl.formatMessage({ id: 'level3.distribution' })}
          iconName="Distribution"
          isActive={props.network === '1'}
          onClick={() => props.updateNetwork('1')}
          isToggle
        />
      )}
      {['2', 'all'].includes(props.network) && (
        <FilterSelect
          data-testid="filter-select-transmission"
          label={intl.formatMessage({ id: 'level3.transmission' })}
          iconName="Transmission"
          isActive={props.network === '2'}
          onClick={() => props.updateNetwork('2')}
          isToggle
        />
      )}
    </>
  );
};
